import { render, staticRenderFns } from "./communicating_tables_lists.vue?vue&type=template&id=5720f4a2&"
import script from "./communicating_tables_lists.vue?vue&type=script&lang=js&"
export * from "./communicating_tables_lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports